import React, { Component } from "react";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation, Trans } from 'react-i18next';
import * as userActions from 'actions/userActions';
import { appService } from "services";
import SubmitButton from "components/SubmitButton";
import Loading from "components/Loading";
import Logo from "components/Logo";
import { transLnkComponents } from "utils/i18nComponents";

class NewPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isAvailable: true,
			isLoading: true,
			isSending: false,
			isChanged: false,
			password_new: '',
			confirmPassword: '',
		};
	}

	async componentDidMount() {
		const response = await appService.getPasswordToken(this.props.match.params.token);
		this.setState({ isAvailable: response.ok, isLoading: false });
	}

	validateForm() {
		const { password_new, confirmPassword } = this.state;
		return password_new.length > 5 && password_new === confirmPassword;
	}

	handleChange = event => {
		this.setState({ [event.target.id]: event.target.value });
	}

	handleSubmit = async event => {
		event.preventDefault();
		this.setState({ isSending: true });
		const response = await appService.newPassword(this.props.match.params.token, this.state.password_new);
		this.setState({
			password_new: '',
			confirmPassword: '',
			isChanged: response.ok,
			isSending: false,
		});
	}

	getContent = () => {
		const { t } = this.props;

		if (this.state.isLoading) return <Loading />;

		if (!this.state.isAvailable) {
			return (
				<div className="notfound container-sm">
					<h3>:(</h3>
					<p>
						<Trans
							i18nKey="newPassword.expiredLink"
							components={transLnkComponents.rememberPassword}
						/>
					</p>
				</div>
			);
		}

		const { password_new, confirmPassword } = this.state;

		return (
			<form onSubmit={this.handleSubmit} className="login-form">
				<p className="hello">{t('newPassword.setPasswordHint')}</p>

				<FormGroup className="form-group login-form-group" controlId="password_new">
					<FormLabel>{t('login.password')} <span className="label-required">*</span></FormLabel>
					<FormControl
						value={password_new}
						onChange={this.handleChange}
						type="password"
						placeholder="••••••••"
					/>
				</FormGroup>
				<FormGroup className="form-group login-form-group" controlId="confirmPassword">
					<FormLabel>{t('invitation.passwordConfirm')} <span className="label-required">*</span></FormLabel>
					<FormControl
						value={confirmPassword}
						onChange={this.handleChange}
						type="password"
						placeholder="••••••••"
					/>
				</FormGroup>

				{this.state.isChanged && (
					<div className="alert alert-success alert-dismissible fade show" role="alert">
						<Trans
							i18nKey="newPassword.successMessage"
							components={transLnkComponents.login}
						/>
					</div>
				)}

				<SubmitButton
					block
					disabled={!this.validateForm()}
					type="submit"
					isLoading={this.state.isSending}
					text={t('newPassword.changeBtn')}
					loadingText={t('newPassword.updating')}
				/>
			</form>
		);
	}

	render() {
		const { t } = this.props;
		return (
			<div className="Auth">
				<div className="remember-block">
					<div className="login-container">
						<Link to="/">
							<Logo className="logo" type="logo" />
						</Link>
						<div className="login-title">{t('newPassword.title')}</div>
						{this.getContent()}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (reducers) => reducers.authReducer;

export default connect(mapStateToProps, userActions)(withTranslation()(NewPassword));
